
import heroHeader from "./components/hero-header.json"
import image from "./components/image.json"
import mapsPreview from "./components/maps-preview.json"
import spacer from "./components/spacer.json"
import text from "./components/text.json"
import button from "./components/button.json"
import title from "./components/title.json"
import rowOfContents from "./components/row-of-contents.json"
import simpleSlider from "./components/simple-slider.json"
import contactForm from "./components/contact-form.json"
import cardImageTitle from "./components/card-image-title.json"
import categoryList from "./components/category-list.json"
import categorySlider from "./components/category-slider.json"
import expansionContent from "./components/expansion-content.json"
import heroDetail from "./components/hero-detail.json"
import numericList from "./components/numeric-list.json"
import paginatedTable from "./components/paginated-table.json"
import galleryImages from "./components/gallery-images.json"
import pagesList from "./components/pages-list.json"
import simpleTable from "./components/simple-table.json"
import video from "./components/video.json"
import html from "./components/html.json"
// # custom components
import simpleform from "./components/simple-form.json"
import iconTitleSubtitle from "./components/icon-title-subtitle.json"
import ExclamationQuestionMark from "./components/exclamation-question-mark.json"
import HeroCover from "./components/hero-cover.json"
import lineOfLogos from "./components/line-of-logos.json"
import ModalContent from "./components/modal-content.json"
import quote from "./components/quote.json"
import salesforceform from "./components/salesforceform.json"
import modelProduct from "./components/model-product.json"
import timeline from "./components/timeline.json"
import lineconnection from "./components/lineconnection.json"
import videoPlayer from "./components/video-player.json"



export default [
    button,
    cardImageTitle,
    categoryList,
    categorySlider,
    contactForm,
    expansionContent,
    ExclamationQuestionMark,
    galleryImages,
    heroDetail,
    HeroCover,
    heroHeader,
    html,
    iconTitleSubtitle,
    image,
    lineOfLogos,
    lineconnection,
    mapsPreview,
    ModalContent,
    modelProduct,
    numericList,
    paginatedTable,
    pagesList,
    quote,
    rowOfContents,
    simpleform,
    salesforceform,
    simpleSlider,
    simpleTable,
    spacer,
    text,
    title,
    timeline,
    video,
    videoPlayer
]
